import React from "react";
import getActivityTag from "./getActivityTag";
import { LOCATION_TYPE } from "../../Location/Data";

const activities = [
  {
    key: 1,
    value: "collection",
    label: (
      <div className="flex items-center px-2 py-2 gap-x-3">
        {getActivityTag("1")}
      </div>
    ),
  },
  {
    key: 2,
    value: "delivery",
    label: (
      <div className="flex items-center px-2 py-2 gap-x-3">
        {getActivityTag("2")}
      </div>
    ),
  },
  {
    key: 3,
    value: "aggregation",
    label: (
      <div className="flex items-center px-2 py-2 gap-x-3">
        {getActivityTag("3")}
      </div>
    ),
  },
];

const getActivities = ({ stops, id }) => {
  const currentStop = stops?.find((s) => s.id === id);

  // if current stop's location type = delivery -> return only delivery activity
  if (currentStop?.locationType === LOCATION_TYPE.DELIVERY) {
    return activities.filter((a) => a.key === LOCATION_TYPE.DELIVERY);
  }

  // if current stop's location type = collection -> return all activities
  return activities;
};

export default getActivities;
